import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {useEffect, useMemo, useState} from "react";
import {useNavigate} from "react-router-dom";
import { toast } from 'react-toastify';
import TabsMenu from "../reusableElementsComponents/TabsMenu";
import TeamReviewGeneralEdit from './TeamReviewGeneralEdit';
import TeamReviewAssessmentsEdit from './TeamReviewAssessmentsEdit';
import WriteAccessGuard from '../reusableElementsComponents/WriteAccessGuard';
import VisibilityIcon from "@mui/icons-material/Visibility";
import B2BApiService from "../../B2bApiService";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Modal from '@mui/material/Modal';
import * as Constants from "../../constants";
import * as Utils from '../../Utilities';
import { t } from '../../content';

function TeamReviewEdit({teamsData, selectedTeamHash, setIsLoadingSingleTeam, refreshSingleTeamData}) {

    let [teamData, setTeamData] = useState(null);
    let [teamDataEdited, setTeamDataEdited] = useState(null);
    let [teamDataEditedFlag, setTeamDataEditedFlag] = useState(false);
    let [deleteTeamModalShow, setDeleteTeamModalShow] = useState(false);

    const navigate = useNavigate();

    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    }, []);

    useEffect(() => {
        if (teamsData && teamsData.length > 0 && selectedTeamHash) {
            const team = teamsData.find(team => team.hash === selectedTeamHash);
            if (team) {
                setTeamData(team);
                setTeamDataEdited(team);
                setTeamDataEditedFlag(false);
            } else {
                setTeamData(null);
                setTeamDataEdited(null);
                setTeamDataEditedFlag(false);
            }
        } else if (selectedTeamHash) {
            setIsLoadingSingleTeam(true);
            b2bServiceObj.LoadTeamByHash(selectedTeamHash, (data) => {
                setIsLoadingSingleTeam(false);
                setTeamData(data);
                setTeamDataEdited(data);
                setTeamDataEditedFlag(false);
            });
        } else {
            setTeamData(null);
            setTeamDataEdited(null);
            setTeamDataEditedFlag(false);
        }
    }, [teamsData, selectedTeamHash, b2bServiceObj, setIsLoadingSingleTeam]);

    const doSave = () => {
        // we need to check if there is any change in the data
        let teamToBeSaved = {
            hash : teamData.hash,
            title : teamDataEdited.title,
            industry_id : teamDataEdited.industry.id,
            description : teamDataEdited.description,
            member_list : teamDataEdited.members.map(member => ({
                email: member.email,
                first_name: member.first,
                last_name: member.last,
            })),
            assessments : teamDataEdited?.assessments
        }
        b2bServiceObj.UpdateTeam(teamToBeSaved, (status, response) => {
            if (status && response.ok && response.httpStatus === 200) {
                toast.success(t('teams.toasts.updated'), {containerId: "teamManagementToast"});
                setTeamData(response.json.data[0])
                refreshSingleTeamData(teamData.hash);
                setTeamDataEditedFlag(false)
            }else{
                toast.error(t('teams.toasts.updateError'), {containerId: "teamManagementToast"});
            }
        })
    }

    const deleleteTeam = () => {
        try {
            b2bServiceObj.DeleteTeam(teamData.hash).then((response) => {
                if (response && response.httpStatus === 200) {
                    toast.success(t('teams.toasts.deleted'), {containerId: "teamManagementToast"});
                    setDeleteTeamModalShow(false);
                    window.location.reload()
                } else {
                    toast.error(t('teams.toasts.deleteError'), {containerId: "teamManagementToast"});
                }
            }).catch((error) => {
                console.error("Error deleting team: ", error);
                toast.error(t('teams.toasts.deleteSystemError'), {containerId: "teamManagementToast"});
            });
        } catch (error) {
            console.error("Error in delete team function: ", error);
            toast.error(t('teams.toasts.deleteUnexpected'), {containerId: "teamManagementToast"});
        }
    }

    let template = {
        tabs: [
            {
                component: <TeamReviewGeneralEdit
                    data={teamDataEdited}
                    updateData = {setTeamDataEdited}
                    teamHash={teamData?.hash}
                    dataEditedFlag={teamDataEditedFlag}
                    setDataEditedFlag={setTeamDataEditedFlag}
                />,
                sectionTitle: t('teams.tabs.general')
            },
            {
                component: <TeamReviewAssessmentsEdit 
                    data={teamDataEdited?.assessments} 
                    updateData={data => setTeamDataEdited({
                        ...teamDataEdited,
                        assessments: data})}
                    dataEditedFlag={teamDataEditedFlag}
                    setDataEditedFlag={setTeamDataEditedFlag}
                />,
                sectionTitle: t('teams.tabs.assessments')
            }
        ]
    }
    return (
        <>
            {<div className="flex flex-row justify-content-space-between" style={{marginBottom:"30px"}}>
                <Button
                    className={'mazhrBtn light-green'}
                    onClick={()=> {
                        navigate('/talents/' + teamData.hash + Constants.URL_WITH_HASH_FOR_TEAM_CHECK)
                        localStorage.setItem(Constants.LOCAL_STORAGE_KEY_SEARCH_TYPE, Constants.SEARCH_TYPE_TARGET_POSITION)
                    }
                    }>
                    <VisibilityIcon/> &nbsp; {t('teams.viewMembers')}
                </Button>
                &nbsp;&nbsp;&nbsp;
                {![Constants.USER_ROLE_TEAMLEAD, Constants.USER_ROLE_SPECIALIST].includes(Utils.currentUserRole()) &&
                <div>
                    <WriteAccessGuard>
                        <Button className={`mazhrBtn default-green ${teamDataEditedFlag ? 'blinking-border-button' : ''}` } onClick={doSave} disabled={!teamDataEditedFlag}>
                            <SaveIcon/> &nbsp; {t('common.actions.saveShort')}
                        </Button>
                    </WriteAccessGuard>
                    {![Constants.USER_ROLE_MANAGER].includes(Utils.currentUserRole()) &&
                        <WriteAccessGuard>
                            <Button className="mazhrBtn default-red mar-45 left" onClick={() => setDeleteTeamModalShow(true)}>
                                <DeleteForeverIcon/> &nbsp; {t('common.actions.delete')}
                            </Button>
                        </WriteAccessGuard>
                    }
                </div>}

            </div>}
            {<TabsMenu template={template} />}
            <Modal
                open={deleteTeamModalShow}
                title={''}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                slotProps={{
                    backdrop: {
                        sx: {
                            height: "100vh",
                        },
                    },
                }}
            >
                <div style={{ 
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 'fit-content',
                    minWidth: '500px',
                    height: 'fit-content',
                    minHeight: '500px',
                    backgroundColor: 'white',
                    padding: '30px',
                    textAlign: 'center',
                    alignContent: 'center',
                    // alignItems: 'center',
                    borderRadius: '10px',
                }}>
                    {/* {loading ? <img src={loadingImage} alt="Loading..." /> : <> */}
                        <h4>{t('teams.deleteConfirmTitle', { title: teamData?.title })}</h4>
                        <p className="red">{t('teams.deleteConfirmCannotUndo')}
                            <br/>
                            {t('teams.deleteConfirmData')}
                            <br/>
                            {t('teams.deleteConfirmTalentAccess')}
                        </p>
                        <div  className="flex justify-content-center">
                            <button className="mazhrBtn default-green white mar-25 right" onClick={deleleteTeam}>{t('common.actions.confirm')}</button>
                            <button  className="mazhrBtn light-grey white" onClick={() => setDeleteTeamModalShow(false)}>{t('common.actions.cancel')}</button>
                        </div>
                    {/* </>
                    } */}
                </div>
            </Modal>
        </>
    )
}

export default TeamReviewEdit;
